import React, { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../../components/auth/auth-context';
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useResetPasswordToken } from '../../hooks/auth/Users';
import { error } from '../../hooks/global/ToastAlert';
import LanguagesSelector from '../../components/public/LanguagesSelectorLogin';
import { useGetAvailableTranslation } from '../../hooks/global/Languages';

const LoginPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated, setIsAuthenticated, login, logout, switchVendor } = useContext(AuthContext);
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const { userId } = useParams();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [resetPasswordState, setResetPasswordState] = useState("hidden"); // hidden, visible, triggered

    const { mutate } = useResetPasswordToken();
    const languages = useGetAvailableTranslation();
    const location = useLocation();

    const handleSubmit = (event) => {
        event.preventDefault();
        login({ username, password });
        navigate('/admin/');
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const lng = params.get('l');
        if (lng) {
            i18n.changeLanguage(lng.toUpperCase());
        }
    }, [location.search, i18n]);

    useEffect(() => {
        if (userId) {
            console.log('sending ready', process.env.REACT_APP_SUPER_ADMIN_HOST);
            window.opener.postMessage('ready', process.env.REACT_APP_SUPER_ADMIN_HOST);
            window.opener.postMessage('ready', process.env.REACT_APP_SUPER_ADMIN_HOST2);


            const handleMessage = (event) => {
                console.log('received', event.origin, event.data?.token, event.data);

                if (event.origin === process.env.REACT_APP_SUPER_ADMIN_HOST || event.origin === process.env.REACT_APP_SUPER_ADMIN_HOST2){
                    const receivedData = event.data

                    if (receivedData?.token) {
                        //logout();

                        const vendorId = receivedData.vendor.id;

                        // Use localStorage to store received data
                        localStorage.setItem('token', receivedData.token);
                        localStorage.setItem('isAuthenticated', 'true'); // Store boolean as a string
                        localStorage.setItem('user', JSON.stringify(receivedData.user));
                        localStorage.setItem('vendor', JSON.stringify(receivedData.vendor));
                        
                        setIsAuthenticated(true);
                        setShouldNavigate(true);

                        localStorage.setItem('vendorId', vendorId);
                        localStorage.setItem('admin', JSON.stringify(receivedData.admin));
                        switchVendor(vendorId);
                    }
                }
            }

            window.addEventListener('message', handleMessage);

            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
    }, [userId, setIsAuthenticated, logout, setShouldNavigate]);

    if (shouldNavigate || (isAuthenticated && !userId)) {
        return <Navigate to="/admin/" replace />;
    }

    const handleSubmitResetPassword = (event) => {
        event.preventDefault();
        // error("asd");
        mutate({ username, lng:i18n.language }, {
            onSuccess: (data) => {
                if (data.status === "success") {
                    setResetPasswordState("triggered");
                }
            },
            onError: (err) => {
                error(err.response.data.error, 1000, "top-center");
            }
        })
    }

    return (
        <div className="container container-relative adminLogIn" tabIndex="0">
             <LanguagesSelector lang={languages} />
            <div id="adminLogin">
                <div className="adminLoginWrap">
                    {resetPasswordState === "triggered" && (
                        <div className="row">
                            <div className="adminLoginForm adminLoginResetDone">
                                <div className="col-md-12 adminLoginHeader text-center clearifix">
                                    <h2>{t("login.check")}</h2>
                                    <p>{t("login.reqSent")}</p>
                                </div>
                                <div className="col-md-12 adminLoginBack text-center clearifix">
                                    <a href='#' onClick={(e) => setResetPasswordState("hidden")}>
                                        « {t("login.toLogin")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}

                    {resetPasswordState === "visible" && (
                        <div className="row">
                            <div className="adminLoginForm adminLoginReset">
                                <div className="col-md-12 adminLoginHeader text-center clearfix">
                                    <h2>{t("login.forgot")}</h2>
                                    <p>{t("login.writeEmail")}</p>
                                </div>
                                <div className="col-md-12 adminLoginInput clearfix">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={username}
                                        placeholder={t("login.email")}
                                        onChange={(e) => setUsername(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                                <div className="col-md-12 adminLoginSubmit clearfix">
                                    <a onClick={handleSubmitResetPassword}>
                                        {t("login.newPass")}
                                    </a>
                                </div>
                                <div className="col-md-12 adminLoginBack text-center clearfix">
                                    <a onClick={(e) => setResetPasswordState("hidden")}>
                                        « {t("login.toLogin")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}

                    {resetPasswordState === "hidden" && (
                        <div className="row">
                            <form className="adminLoginForm adminLoginMain">
                                <div className="col-md-12 adminLoginHeader text-center clearfix">
                                    <h2>{t("login.login")}</h2>
                                </div>
                                <div className="col-md-12 adminLoginInput clearfix">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeholder={t("login.email")}
                                        autoFocus
                                    />
                                </div>
                                <div className="col-md-12 adminLoginInput clearfix">
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="form-control password"
                                        placeholder={t("common.password")}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="adminLoginInput adminLoginInputCheckbox">
                                                <input
                                                    id="rememberPass"
                                                    type="checkbox"
                                                    checked={rememberMe}
                                                    onChange={(e) => setRememberMe(e.target.checked)}
                                                    className=""
                                                />
                                                <label htmlFor="rememberPass">
                                                    {t("login.reme")}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <div className="adminLoginLostPassword text-md-end">
                                                <a href='#1' onClick={(e) => setResetPasswordState("visible")}>
                                                    {t("login.didFor")}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 adminLoginSubmit clearfix">
                                    <a href='#1' onClick={handleSubmit}>
                                        {t("login.login")}
                                    </a>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LoginPage;